import React, {CSSProperties} from 'react';
import {useTemplate} from '../../context/TemplateContext';
import {useMobile} from '../../context/MobileContext';
import {DesignGridContainer, DesignOption, DesignOptionWrapper} from "./components/DesignButtons";
import {designLabel} from "../../models/Template";


interface AvailableDesignGridProps {
    designContainerHeight: number;
    selectedDesign: number;
    handleDesignChange: (index: number) => void;
    style?: CSSProperties;
}

const AvailableDesignGrid: React.FC<AvailableDesignGridProps> = ({
                                                                     designContainerHeight,
                                                                     selectedDesign,
                                                                     handleDesignChange,
                                                                     style
                                                                 }) => {
    const {template} = useTemplate();
    const {isMobile} = useMobile();

    return (
        <>
            {template && (
                <DesignGridContainer
                    container
                    direction="row"
                    sx={{
                        width: isMobile ? "100%" : "unset",
                        marginBottom: isMobile ? 0.5 : "11px",
                        ...style
                    }}
                >
                    <DesignOptionWrapper
                        sx={{
                            justifyContent: isMobile ? "center" : "unset",
                        }}>
                        {template?.designs.map((design, index) => (
                            <DesignOption
                                key={`design-${index}`}
                                variant="h6"
                                isActive={selectedDesign === index}
                                onClick={() => handleDesignChange(index)}
                            >
                                {designLabel(design)}
                            </DesignOption>
                        ))}
                    </DesignOptionWrapper>
                </DesignGridContainer>
            )}
        </>
    );
};

export default AvailableDesignGrid;